import React from "react";
import PropTypes from "prop-types";
import { Wrapper } from "./Wrapper";
import { DesignChapter } from "@learningblocks/storybook-components/";
import { StreakCounter } from "./StreakCounter";

import cn from "./style.module.scss";

export function DesignChapterContentBlock(props) {
  const [current, setCurrent] = React.useState("TECHNIQUES");

  const onTabSelect = (tab) => {
    setCurrent(tab);
  };

  const renderOptions = () => {
    switch (props.viewType) {
      case "STEPS":
        return (
          <DesignChapter.StepOptions
            title={props.options.title}
            list={props.options.list}
            onSetStep={props.onSetStepViewThree}
          />
        );
      case "TECHNIQUES":
        return (
          <DesignChapter.TechniqueOption
            options={props.options}
            current={current}
            onSetStep={props.onSetStepViewFour}
            onTabSelect={onTabSelect}
          />
        );
      default:
        return null;
    }
  };

  const className = `${cn["contentBlock_wrapper--wrapper"]} ${
    cn[{ STEPS: "add-padding" }[props.viewType] ?? "no-padding"]
  }`;

  return (
    <Wrapper className={cn.contentBlock_wrapper}>
      <StreakCounter />
      <Wrapper className={`${className} optionsWrapper `}>
        {renderOptions()}
      </Wrapper>
    </Wrapper>
  );
}

DesignChapterContentBlock.propTypes = {
  /**
   * classname for Design Section content
   */
  className: PropTypes.string,
  /**
   * specifes current active tab
   */
  viewType: PropTypes.oneOf(["STEPS", "TECHNIQUES"]),
  /**
   * details for step options
   */
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        /**
         * Title of the Options block
         */
        title: PropTypes.string,
        /**
         * List of options
         */
        list: PropTypes.arrayOf(
          PropTypes.shape({
            /**
             * Uniqe id of the option
             */
            id: PropTypes.number,
            /**
             * Main title text of the option
             */
            text: PropTypes.string,
            /**
             * Theme color of the option
             */
            color: PropTypes.string,
          })
        ),
      })
    ),
    PropTypes.shape({
      /**
       * Title of the Options block
       */
      title: PropTypes.string,
      /**
       * List of options
       */
      list: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * Uniqe id of the option
           */
          id: PropTypes.number,
          /**
           * Main title text of the option
           */
          text: PropTypes.string,
          /**
           * Theme color of the option
           */
          color: PropTypes.string,
        })
      ),
    }),
  ]),
  /**
   *  function to invoke on clicking step for stepOptions
   */
  onSetStepViewThree: PropTypes.func,
  /**
   * function to invoke on clicking step for TechniqueOptions
   */
  onSetStepViewFour: PropTypes.func,
};
